import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Stale-build recovery: after a redeploy, cached pages reference old JS chunks
// that no longer exist. Force ONE reload to fetch the fresh build.
window.addEventListener("error", (e) => {
  const msg = e?.message || "";
  if (/Loading chunk|ChunkLoadError|Loading CSS chunk/i.test(msg)) {
    const key = "chunk_reload_ts";
    const last = Number(sessionStorage.getItem(key) || 0);
    if (Date.now() - last > 60000) {
      sessionStorage.setItem(key, String(Date.now()));
      window.location.reload();
    }
  }
});
window.addEventListener("unhandledrejection", (e) => {
  const msg = e?.reason?.message || "";
  if (/Loading chunk|ChunkLoadError|dynamically imported module/i.test(msg)) {
    const key = "chunk_reload_ts";
    const last = Number(sessionStorage.getItem(key) || 0);
    if (Date.now() - last > 60000) {
      sessionStorage.setItem(key, String(Date.now()));
      window.location.reload();
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
